import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const skillsData = [
  { category: "Gen AI & LLM Frameworks", skills: ["Claude-Code", "Gemini CLI", "OpenAI CODEX", "LangChain", "RAG", "Prompt Engineering", "Conversational AI", "Computer Vision"] },
  { category: "Vector DBs & MLOps", skills: ["Pinecone", "FAISS", "MLOps", "AI Security Protocols", "SLA Compliance", "Rapid Prototyping (POCs)", "Vibe Coding"] },
  { category: "End-to-End Cloud", skills: ["AWS", "GCP", "Azure", "Kubernetes", "Docker", "Terraform", "GitHub Actions"] },
  { category: "Governance & Strategy", skills: ["P&L Ownership", "C-Level Advisory", "Program Governance", "Delivery Excellence", "AI Factory Architecture"] },
  { category: "Fullstack & Enterprise", skills: ["Fullstack React JS", "Python", "Node.js", "SAGE X3", "Odoo", "ERP Everywhere", "Appsmith"] }
];

const Skills = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.15 } }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
  };

  return (
    <section id="skills" className="container" ref={ref} style={{ padding: '50px 0' }}>
      <h2 className="section-title">
        Core <span className="text-gradient">Competencies</span>
      </h2>

      <motion.div 
        variants={containerVariants}
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
        style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' }}
      >
        {skillsData.map((group, i) => (
          <motion.div key={i} variants={itemVariants} className="glass-panel" style={{ padding: '2rem' }}>
            <h3 style={{ fontSize: '1.3rem', marginBottom: '1.5rem', color: 'var(--accent-cyan)' }}>{group.category}</h3>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
              {group.skills.map((skill, j) => (
                <motion.span 
                  key={j}
                  whileHover={{ scale: 1.1, backgroundColor: 'rgba(255,255,255,0.1)' }}
                  style={{
                    padding: '8px 16px', background: 'rgba(255,255,255,0.03)',
                    border: '1px solid rgba(255,255,255,0.1)', borderRadius: '20px',
                    fontSize: '0.9rem', color: 'var(--text-secondary)', cursor: 'default'
                  }}
                >
                  {skill}
                </motion.span>
              ))}
            </div>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default Skills;
